module.exports = __webpack_public_path__ + "0f84d57ec49e3a63d57d3244c3ea4a59.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Eesti-Display-Regular.ttf
// module id = 41
// module chunks = 0